<div class="row" *ngFor="let deliveryLocation of data; let first = first">
  <!-- <div *ngIf="first" class="col-12 text-right">
    <button type="button" class="btn btn-primary" (click)="openModalCreate(deliveryLocation)">
      <i class="fas fa-plus mr-1"></i>
      <span translate>ADD</span>
    </button>
  </div> -->
  <div class="col-10">
    <h4>{{ deliveryLocation.name }}</h4>
  </div>
  <!-- <div class="col-2 align-self-center text-right">
    <button type="button" class="btn btn-secondary" (click)="openModalEdit(deliveryLocation)">
      <i class="fas fa-edit mr-1"></i>
      <span translate>EDIT</span>
    </button>
  </div> -->
  <div class="col-12 col-md-6">
    <div class="form-group">
      <label class="control-label" for="address" translate>FR_FTGPOSTADR1</label>
      <input
        class="form-control"
        name="address"
        type="text"
        [(ngModel)]="deliveryLocation.extra.fr.ftgpostadr5"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_FTGPOSTADR2</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="deliveryLocation.extra.fr.ftgpostadr1"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="postalCode" translate>FR_FTGPOSTNR</label>
      <input
        class="form-control"
        name="postalCode"
        type="text"
        [(ngModel)]="deliveryLocation.extra.fr.ftgpostnr"
        disabled
      />
    </div>
  </div>
  <div class="col-12 col-md-6">
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_FTGPOSTADR3</label>
      <input
        class="form-control"
        name="city"
        type="text"
        [(ngModel)]="deliveryLocation.extra.fr.ftgpostadr3"
        disabled
      />
    </div>
    <div class="form-group">
      <label class="control-label" for="city" translate>FR_LANDSKOD</label>
      <input class="form-control" name="city" type="text" [(ngModel)]="deliveryLocation.extra.fr.landskod" disabled />
    </div>
  </div>
</div>
